module.exports = __webpack_public_path__ + "static/img/img_logo21_m.77a7157.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img_logo21_m.png
// module id = cdze
// module chunks = 5